export const crmSelectors = {
  getSearchedContacts: state => state.crm.searchedContacts,
  isSearching: state => state.crm.isSearching,
};
